import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useAuth } from "../providers/AuthProvider";
import { useResponsiveBreakpoint } from "./useResponsiveBreakpoint";

const HIDDEN_PATH_PREFIXES = [
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/auth",
  "/verify-email",
  "/workspaces/invite",
  "/legal",
  "/billing/checkout",
  "/admin",
];

export function useMobileNavVisibility() {
  const { pathname } = useLocation();
  const { isMobile } = useResponsiveBreakpoint();
  const { accessToken } = useAuth();

  const shouldShowMobileNav = useMemo(() => {
    if (!accessToken || !isMobile) {
      return false;
    }
    return !HIDDEN_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
  }, [accessToken, isMobile, pathname]);

  return { shouldShowMobileNav };
}
